import React, { Component } from 'react'
import { Container, Row, Table, Pagination, Form } from 'react-bootstrap'
import api from '../api/index.js'
import { debounce } from 'lodash'
// import '../css/table.css'

/**
 * TableDemo component class.
 * Variables in state:
 * @data Data used in chart.js. Default is empty chart.js datasets.
 * @year Current picked year for the chart. Default is last year.
 * @checks Checkboxes state.
 * 
 * Variables in class:
 * @chart Chart.js instance.
 * @rawData The raw data stored from database.
 * @buildings The buildings shown in the chart. Usually it is top 10 buildings with most spends
 * @retrievedYear The year of which data has been retrieved from the database.
 */
export default class TableDemo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            computedData: [],
            activePage: 1,
            buffer: '',
            keywords: '',
        };
        this.headers = ['Bangunan', 'Bulan', 'Jumlah Tagihan', 'Tarif/Daya'];
        this.dataMap = [
            'name_building',
            'bulan',
            'jumlah tagihan (Rp)',
            'tarif/daya (VA)',
        ];
        this.maxTablePage = 10;
    }

    /* React Lifecycle function to get initial data from database */
    componentDidMount = async () => {
        this.getFromDatabase();
    };

    getFromDatabase = async () => {
        let data = [...this.state.data];

        let criteria = {
            location: 'Kampus Ganesa',
            month: 'All',
            year: 'All',
            start: 0,
            size: 50,
        };
        await api
            .getListrikForTable(criteria)
            .then((res) => {
                data = [...data, ...res.data.data];
            })
            .catch((err) => {
                console.log(err);
            });
        this.setState({
            data,
        }, () => this.computeData());
    };

    handlePaginationClick = (page) => {
        this.setState({
            activePage: page,
        });
    };

    onSubmitHandler = debounce(() => {
        this.setState({ keywords: this.state.buffer }, () => this.computeData());
    }, 500);

    onUserTyping = e => {
        e.preventDefault();
        if (
            e.target.value.charCodeAt(0) >= 48 &&
            e.target.value.charCodeAt(0) <= 57
        ) {
            this.setState({ buffer: e.target.value, keywords: e.target.value }, () => this.computeData());
        } else {
            this.setState({ buffer: e.target.value }, () => {
                this.onSubmitHandler();
            });
        }
    };

    computeData = () => {
        let data = this.state.data.filter(x => x['name_building'].toLowerCase().includes(this.state.keywords))
        this.setState({
            computedData: data,
            activePage: 1
        })
    }

    /* React Lifecycle render function */
    render() {
        const { activePage, computedData } = this.state;
        const tableItems = [];
        if (computedData.length > 0) {
            for (
                let i = (activePage - 1) * this.maxTablePage;
                i < Math.min(computedData.length, activePage * this.maxTablePage);
                i++
            ) {
                tableItems.push(
                    <tr>
                        {this.dataMap.map((key, j) =>
                            key === 'PDF/IMG' ? (
                                <td key={`${i}.${j}`}>
                                    <a
                                        key={`a${i}.${j}`}
                                        href={`https://${computedData[i][key]}`}
                                        target="_blank"
                                    >
                                        {computedData[i][key]}
                                    </a>
                                </td>
                            ) : (
                                <td key={`${i}.${j}`}>{computedData[i][key]}</td>
                            )
                        )}
                    </tr>
                );
            }
        }
        const paginationItems = [];
        for (let i = 1; i <= computedData.length / this.maxTablePage; i++) {
            paginationItems.push(
                <Pagination.Item
                    key={i}
                    active={i === activePage}
                    onClick={() => this.handlePaginationClick(i)}
                >
                    {i}
                </Pagination.Item>
            );
        }
        return (
            <Container>
                <h4>Tabel Data</h4>
                <Form>
                    <Form.Group controlId="formTableSearch">
                        <Form.Label className="pl-4">
                            Filter pencarian
                        </Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Masukkan nama bangunan..."
                            value={this.state.buffer}
                            onChange={e => this.onUserTyping(e)}
                        />
                    </Form.Group>
                </Form>
                <Table striped bordered hover size="sm">
                    <thead>
                        <tr>
                            {this.headers.map((header, idx) => (
                                <th key={idx}>{header}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>{tableItems}</tbody>
                </Table>
                <Pagination>
                    <Pagination.First
                        onClick={() => this.handlePaginationClick(1)}
                    />
                    {activePage > 1 ? (
                        <Pagination.Prev
                            onClick={() =>
                                this.handlePaginationClick(activePage - 1)
                            }
                        />
                    ) : null}
                    {paginationItems}
                    {activePage < computedData.length / this.maxTablePage ? (
                        <Pagination.Next
                            onClick={() =>
                                this.handlePaginationClick(activePage + 1)
                            }
                        />
                    ) : null}
                    <Pagination.Last
                        onClick={() =>
                            this.handlePaginationClick(
                                computedData.length / this.maxTablePage
                            )
                        }
                    />
                </Pagination>
            </Container>
        );
    }
}
